import { Box, IconButton } from "@mui/material";
import ControlPointDuplicateIconOutlined from '@mui/icons-material/ControlPointDuplicateOutlined';
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { getTicketTypeByValue } from "../../constants/enums";


const ticketsColumns = ( handleDuplicate, handleView, handleEdit, handleDelete, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "day",
    headerName: "Día",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "dosage_count",
    headerName: "Cantidad de Dosis",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
  },
  {
    field: "type",
    headerName: "Tipo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getTicketTypeByValue(params.value);

      return (
      <Box
        sx={{
          color: typeInfo.color,
          fontWeight: "bold",
          backgroundColor: `${typeInfo.color}30`, // Transparent background
          border: ` ${typeInfo.color}`, // Corner borders
          borderRadius: "8px", // Rounded corners
          padding: "8px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
          height: "50%",
          textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
          overflow: "hidden", // Prevent shadow from going outside the box
        }}
      >
        {typeInfo.label}
      </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.7,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
            <VisibilityOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleEdit(params.row.id)} sx={{ color: colors.grey[100] }}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleDuplicate(params.row.id)} sx={{ color: colors.grey[100] }}>
            <ControlPointDuplicateIconOutlined />
        </IconButton>
        <IconButton onClick={() => handleDelete(params.row.id)} sx={{ color: colors.grey[100] }}>
          <DeleteOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { ticketsColumns }